import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ApiResponse<T> {
  success: boolean;
  msg: string;
  res: T;
  time: string;
  ver: string;
}

export interface CodeValidationResponse {
  success: boolean;
  msg: string;
  res: string;
  time: string;
  ver: string;
}

export interface ResetPasswordRequest {
  verifyCode: string;
  newPassword: string;
  confirmPassword: string;
}

export interface ChangePasswordRequest {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordRecoveryService {
  private readonly baseUrl = `${environment.apiUrl}/agrosmart-identity-ws/password`;

  constructor(private http: HttpClient) {}

  sendCode(email: string): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/send-code?email=${encodeURIComponent(email)}`, {});
  }

  validateCode(email: string, code: string): Observable<CodeValidationResponse> {
    return this.http.post<CodeValidationResponse>(
      `${this.baseUrl}/code-validation?email=${encodeURIComponent(email)}&code=${code}`,
      {}
    );
  }

  resetPassword(request: ResetPasswordRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/reset-password`, request);
  }

  changePassword(request: ChangePasswordRequest): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.baseUrl}/change-password`, request);
  }
}
